import React from 'react'
import ImagePng from 'components/ImagePng'
import { StaticImage } from 'gatsby-plugin-image'
import Inview from 'components/Inview'
import LinkWrap from 'components/LinkWrap'

const Component = ({ showLogos = true }) => {
  const qr = ['微信视频号', '微信小程序', '抖音', '快手']
  const footerMenu = [
    {
      to: '/locations/',
      text: '店铺地图',
      addClass: 'bottom_map',
    },
    {
      to: '/merchants/',
      text: '星选加盟',
      addClass: 'bottom_join',
    },
    {
      to: '/customers/',
      text: '商户案例',
      addClass: 'bottom_case',
    },
    {
      to: '/about/',
      text: '关于我们',
      addClass: 'bottom_us',
    },
  ]
  return (
    <footer className='footer bg--grey-2'>
      <div className='container md:pt-24 lg:pt-20 pb-10'>
        {showLogos && (
          <Inview>
            <div className='fade-in-up'>
              <div className='logos desktop hidden md:block mb-20'>
                <ImagePng filename='logos-bottom.png' />
              </div>
              <div className='logos phone md:hidden mb-28'>
                <ImagePng filename='logos-bottom-phone.png' />
              </div>
            </div>
          </Inview>
        )}
        <Inview>
          <div className='grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12 pb-12 md:pb-16 lg:pb-24 fade-in-up'>
            <div className='col-span-4 md:col-span-2 lg:col-span-3 logo-qr-wrap'>
              <a aria-current='page' className='logo db' href='/'>
                <ImagePng filename='logo.png' alt='logo' />
              </a>
              <div className='qr-image'>
                <ImagePng filename='微信公众号.png' />
              </div>
            </div>
            <div className='col-span-2 col-start-1 md:col-start-3 lg:col-start-4 mt-12 md:mt-0'>
              <div className='eyebrow mb-8 md:mb-10'>联系我们</div>
              <ul>
                <li>
                  <a
                    href='tel:4008502727'
                    className='btn--text btn--text--large'
                  >
                    400-850-2727
                  </a>
                </li>
                {qr.map((item, i) => (
                  <li key={i} className='qr-wrap'>
                    <a className='btn--text btn--text--large'>{item}</a>
                    <ImagePng filename={`${item}.png`} />
                  </li>
                ))}
              </ul>
            </div>
            <div className='col-span-2 col-start-3 md:col-start-5 lg:col-start-6 mt-12 md:mt-0'>
              <div className='eyebrow mb-8 md:mb-10'>星选闪电</div>
              <ul>
                {footerMenu.map((item, i) => (
                  <li key={i}>
                    <LinkWrap
                      to={item.to}
                      className={`btn--text btn--text--large ${item.addClass}`}
                    >
                      {item.text}
                    </LinkWrap>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Inview>
        <Inview>
          <div className='fade-in-up'>
            <hr />
            {/* <div className='grid md:grid-cols-2 pt-4'> */}
            <div className='pt-4'>
              <p className='caption mb-0'>
                <span>Flash Kitchens ©2021. All rights reserved.</span>{' '}
                <br className='mobile-only' />
                <span>
                  <a href='https://beian.miit.gov.cn' target='_blank'>
                    津ICP备20005574号-2
                  </a>
                </span>{' '}
                <span>未来云厨（天津）企业管理咨询有限责任公司</span>{' '}
                <span>
                  <a href='https://www.lanterndigital.com.cn' target='_blank'>
                    网站设计
                  </a>
                  &nbsp; 投资有风险，加盟需谨慎
                </span>
                <br />
                <span className='before-image'>
                  上海市静安区陕西北路278号4层商场A4-3d
                </span>{' '}
                <span className='has-image'>
                  <a
                    href='http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602006802'
                    target='_blank'
                  >
                    <img src='/footer-icon.png' alt='' />
                    沪公网安备 31010602006802号
                  </a>
                </span>
              </p>
            </div>
            <div className='hidden md:block hide-for-later'>
              <ul className='flex justify-end'>
                <li className='caption'>
                  <a href=''>Privacy policy</a>
                </li>
                <li className='caption ml-12'>
                  <a href=''>Terms &amp; conditions</a>
                </li>
              </ul>
            </div>
            {/* </div> */}
          </div>
        </Inview>
      </div>
      <a href='#' className='btn--circle btn--chat hidden'>
        <svg
          width='21'
          height='22'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M0 1.506C0 .674.648 0 1.448 0h18.104C20.352 0 21 .674 21 1.506v20.117c0 .296-.313.476-.554.32l-6.176-4.817H1.448c-.8 0-1.448-.674-1.448-1.505V1.506z'
            fill='#44433F'
          ></path>
        </svg>
      </a>
    </footer>
  )
}

export default Component
